<template>
  <div class="row">
    <div class="panel bg-transparent columns large-8 medium-12 large-centered text-center">
      <div v-if="componentReady">
        <keep-alive>
          <component
            :display-data="displayData"
            :is="tabComponents[tabIndex]"
            :ge-member-ids="geMemberIds"
            @display-change="val => displayData = val"
            @tab-change="tabChanged"
            @complete="$emit('stage-change', 3)"
          />
        </keep-alive>
      </div>
      <div v-if="!componentReady">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </div>
    </div>
  </div>
</template>

<script>
import $                     from 'jquery';
import CompanyContact        from './Tabs/CompanyContact.vue';
import CompanyEmployees      from './Tabs/CompanyEmployees.vue';
import CompanyServices       from './Tabs/CompanyServices.vue';
import CompanyJurisdications from './Tabs/CompanyJurisdications.vue';
import CompanySubset         from './Tabs/CompanySubset.vue';

export default {

  components: {
    CompanyContact,
    CompanyEmployees,
    CompanyServices,
    CompanyJurisdications,
    CompanySubset,
  },

  props: ['tab', 'geMemberIds'],

  data() {
    return {
      componentReady: false,
      displayData: [],
      tabIndex: 0,
      tabComponents: [
        'company-contact',
        'company-employees',
        'company-services',
        'company-jurisdications',
        'company-subset',
      ],
    };
  },

  activated() {
    if (this.tab > -1) {
      this.tabIndex = this.tab;
    }

    this.$emit('reset-tab', true);
  },

  beforeMount() {
    $.post('/register/tab-data/company', (data) => {
      this.displayData = data;
      this.componentReady = true;
    })
    .fail( () => {
      window.location.href = '/register';
    });
  },

  methods: {
    tabChanged(val) {
      $('html, body').animate({ scrollTop: 100 }, 'slow');

      this.tabIndex = val;
    },
  },
};
</script>
